module.exports = __webpack_public_path__ + "img/teaser_training7.def50c3c.jpg";